import { Injectable } from '@angular/core';
import { Config } from './config/config'
import { HttpClient } from '@angular/common/http'
import { StorageService } from './config/storage.service'

@Injectable({
  providedIn: 'root'
})
export class FundraiserService extends Config{

  constructor(
      private http:HttpClient,
      private storage:StorageService,
  ) { 
     super()
  }

    viewCurrentFundraiser(){
        let url = 'view_current_fundraiser';
        return this.http.get(this.BASE_URL_API_WEBSITE + url,this.storage.getHeaders())
    }

    addFundraiser(item){
        let url = 'add_fundraiser';
        return this.http.post(this.BASE_URL_API_WEBSITE + url,item,this.storage.getHeaders())
    }

    removeItemFundraiser(fd_id){
        let url = 'remove_item_fundraiser?fundraiser_detail_id=' + fd_id;
        return this.http.get(this.BASE_URL_API_WEBSITE + url,this.storage.getHeaders())
    }

    saveFundraiser(fund){
        let url = 'save_fundraiser';
        return this.http.post(this.BASE_URL_API_WEBSITE + url,fund,this.storage.getHeaders())
    }

    viewPublicFundraiser(fundraiser_master_id){
        let url = 'public/view_public_fundraiser?fundraiser_master_id=' + fundraiser_master_id;
        return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
    }


    //   saveItems(item:any){
    //     let url = 'save_items'
    //     return this.http.post(this.BASE_URL_API + url,item,this.storage.getHeaders())
    //   }

    //   getItemDropdowns(){
    //     let url = 'get_item_dropdown'
    //     return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
    //   }


}
